// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FEBouy .modal-dialog {
  max-width: 560px;
  margin: 1.75rem auto;
}

.FEBouy .modal-content {
  border-radius: var(--radius-m);
  border: 1px solid var(--stroke-neutral-subtle);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
  min-height: 448px;
}

.gMc1NP {
  padding: var(--spacing-3) var(--spacing-3) var(--spacing-2);
  border-bottom: 1px solid var(--stroke-neutral-subtle);
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--spacing-1);
}

.ybfEDv {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-medium);
  font-size: 18px;
  line-height: 1;
  color: var(--text-neutral-dark);
  margin: 0;
}

.Tn5pmk {
  background: none;
  border: none;
  padding: var(--spacing-0-5);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  max-width: 32px;
  max-height: 32px;
}

.CDmK63 {
  padding: var(--spacing-3);
  min-height: 320px;
  display: flex;
  flex-direction: column;
}

.Kpn5sY {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  flex: 1 1 auto;
}

.Kpn5sY [data-testid='alert'] {
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
}

.OCLeaJ {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-md);
  color: var(--text-neutral-stronger);
  margin: 0;
  line-height: 1.4;
}

.gA62t2 {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
}

.uG3VoT {
  display: flex;
  align-items: flex-start;
  gap: var(--spacing-2);
  padding: var(--spacing-1-5);
  border: none;
  border-radius: var(--radius-s);
  background: var(--surface-neutral-pale);
  cursor: pointer;
  text-align: left;
  transition: background-color 0.2s;
}

.uG3VoT:hover {
  background-color: var(--surface-primary-subtle);
}

.Yb72FD {
  background-color: var(--surface-primary-subtle);
}

.WkjZj4 {
  width: 16px;
  height: 16px;
  min-width: 16px;
  border-radius: var(--radius-pill);
  border: 1px solid var(--stroke-neutral-dark);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 1px;
  transition:
    border-color 0.2s,
    background-color 0.2s;
}

.eLfKHM {
  border-color: var(--surface-primary-medium);
  background-color: var(--surface-primary-medium);
}

.TsjaG_ {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: var(--surface-neutral-white);
}

.EFnk7x {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
  flex: 1;
  min-width: 0;
}

.Xg9wa6 {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.uiKKHo {
  color: var(--text-neutral-dark);
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.K1rJu8 {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-lg);
  color: var(--text-neutral-dark);
  line-height: 1;
  flex: 1 0 0;
  min-width: 0;
}

.zu9eQl {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  color: var(--text-neutral-dark);
  line-height: 1.6;
}

.fWqgOm {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-0-5);
  height: 20px;
  padding: var(--spacing-0-5);
  border-radius: var(--radius-s);
  background-color: var(--success-green-light);
  border: 1px solid var(--status-success);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: 10px;
  line-height: 1;
  color: var(--text-neutral-dark);
  white-space: nowrap;
  flex-shrink: 0;
}

.AMUByx {
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
}

.poaLQa {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
  min-height: 360px;
}

.poaLQa [data-testid='fileUploadSpreadsheetImport'] {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.poaLQa [data-testid='fileUploadSpreadsheetImport'] > label {
  flex: 1 1 auto;
  min-height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.poaLQa [data-testid='fileUploadSpreadsheetImport-title'] {
  color: var(--text-neutral-stronger);
}

.poaLQa [data-testid='fileUploadSpreadsheetImport-file-error'] {
  display: none;
}

.poaLQa [data-testid='fileUploadSpreadsheetImport'] > label[class*='dragging'] {
  border-style: dashed;
  border-color: var(--stroke-primary-bright);
  background-color: var(--surface-primary-subtle);
}

.poaLQa
  [data-testid='fileUploadSpreadsheetImport']
  > label[class*='dragging']
  [data-testid='fileUploadSpreadsheetImport-title'] {
  color: var(--text-primary-bright);
}

.q3vtLs [data-testid='fileUploadSpreadsheetImport-title'] {
  color: var(--status-error);
}

.yigjFb {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.FsJufi {
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  color: var(--status-error);
  margin-top: calc(-1 * var(--spacing-1));
}

.dGYlIh {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-sm);
  color: var(--text-primary-medium);
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
}

.dGYlIh:hover {
  color: var(--text-primary-strong);
}

.AKNzaN {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-md);
  color: var(--text-primary-medium);
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
}

.AKNzaN:hover:not(:disabled) {
  color: var(--text-primary-strong);
}

.AKNzaN:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.mDtKSW {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-md);
  color: var(--text-primary-medium);
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
}

.mDtKSW:hover {
  color: var(--text-primary-strong);
}

.hzWDph {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
}

.lxMR3u {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
  max-height: 240px;
  overflow-y: auto;
  padding-right: var(--spacing-1);
  scrollbar-color: var(--icon-neutral-silver, #ccc) transparent;
  scrollbar-width: thin;
}

.lxMR3u::-webkit-scrollbar {
  width: 4px;
}

.lxMR3u::-webkit-scrollbar-track {
  background: transparent;
}

.lxMR3u::-webkit-scrollbar-thumb {
  background-color: var(--icon-neutral-silver, #ccc);
  border-radius: var(--radius-pill);
}

._TN0cA {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  color: var(--text-neutral-stronger);
  line-height: 1.6;
  margin: 0;
}

.hM4Gwe {
  font-weight: var(--font-weight-medium);
  color: var(--text-neutral-stronger);
}

.IC72mk {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1 1 auto;
  gap: var(--spacing-3);
  padding: var(--spacing-3);
  text-align: center;
}

.Wi1JPt {
  width: 72px;
  height: 72px;
  border-radius: var(--radius-pill);
  background-color: var(--surface-primary-subtle);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.TzUy5N {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid transparent;
  border-top-color: var(--text-primary-medium);
  border-right-color: var(--text-primary-medium);
  animation: SwoNGT 0.9s linear infinite;
}

@keyframes SwoNGT {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.MlHfK2 {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-lg);
  color: var(--text-neutral-dark);
  line-height: 1.6;
  margin: 0;
  max-width: 420px;
}

.hD9Bst {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1 1 auto;
  gap: var(--spacing-3);
  padding: var(--spacing-3);
  text-align: center;
}

.mPUwYB {
  width: 72px;
  height: 72px;
  border-radius: var(--radius-pill);
  background-color: var(--success-green-light);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.Y75OCw {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-lg);
  color: var(--text-neutral-dark);
  line-height: 1.2;
  margin: 0;
}

.A_2_JA {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  color: var(--text-neutral-dark);
  line-height: 1.6;
  margin: 0;
  max-width: 420px;
}

.H4JaAw {
  font-weight: var(--font-weight-semibold);
}

.ebjh_y {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-2);
  margin-top: var(--spacing-1);
}

.Mhj6Ym {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  flex: 1 1 auto;
}

.N7TfNN {
  display: flex;
  align-items: center;
  gap: var(--spacing-1-5);
  padding: var(--spacing-1-5);
  border-radius: var(--radius-s);
  background: var(--surface-neutral-pale);
}

.ZwYijr {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-0-5);
  flex: 1 1 auto;
  min-width: 0;
  justify-content: flex-end;
}

.fdDD5X {
  display: flex;
  align-items: center;
  gap: var(--spacing-3);
  width: 100%;
}

.gAiXKV {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  color: var(--text-neutral-dark);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.W9GfC2 {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  color: var(--text-neutral-dark);
  margin-left: auto;
  white-space: nowrap;
}

.J6OnyZ {
  position: relative;
  width: 100%;
  height: 4px;
  border-radius: var(--radius-pill);
  background-color: var(--surface-neutral-soft);
  overflow: hidden;
}

.jhFw9M {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 0;
  border-radius: var(--radius-pill);
  background-color: var(--data-series-02);
  animation: G6LHBR 1s ease-in-out forwards;
}

@keyframes G6LHBR {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}

.Vzd1B6 {
  background: none;
  border: none;
  padding: var(--spacing-0-5);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.vnEkcb {
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
}

.h5eZ4Y {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  flex: 1 1 auto;
}

.gt4qZS {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-md);
  color: var(--text-neutral-stronger);
  line-height: 1.4;
  margin: 0;
}

.hl1pzK {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-2);
  border: 1px solid var(--stroke-neutral-subtle);
  border-radius: var(--radius-s);
  background: var(--surface-neutral-pale);
  gap: var(--spacing-2);
}

.PHw1rr {
  border-color: var(--status-error);
}

.D4Y5WU {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
}

.OvqQ4e {
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
}

.gFKKQZ {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  color: var(--text-neutral-dark);
}

.U0xmEY {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  color: var(--text-neutral-dark);
  margin-left: auto;
}

.a3QAHD {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  color: var(--text-neutral-dark);
  line-height: 1;
}

.j_rNGh {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  color: var(--status-error);
  line-height: 1.4;
}

.C8Bp2c {
  background: none;
  border: none;
  padding: var(--spacing-0-5);
  cursor: pointer;
  color: var(--text-neutral-medium);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: var(--spacing-2);
}

.C8Bp2c:hover {
  color: var(--text-neutral-dark);
}

.XWIead {
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
}

.MUmRe6 {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  flex: 1 1 auto;
}

.ifKJc5 {
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
}

.kxwYku {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
  flex: 1 1 auto;
  min-width: 0;
}

.kxwYku [data-testid='alert'] {
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
}

._xBWpx {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.Fb49NV {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  color: var(--text-neutral-dark);
  line-height: 1.4;
}

.t2BhMO {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  color: var(--text-neutral-dark);
  line-height: 1.4;
}

.XBRM1q {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 240px;
  overflow-y: auto;
  padding: 16px 12px;
  background-color: var(--surface-neutral-pale);
  border-radius: 4px;
  scrollbar-color: #ccc transparent;
  scrollbar-width: thin;
}

.XBRM1q::-webkit-scrollbar {
  width: 4px;
}

.XBRM1q::-webkit-scrollbar-track {
  background: transparent;
}

.XBRM1q::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: var(--radius-pill);
  min-height: 80px;
}

.pIRzhd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-2);
  padding: 8px 0;
  border-bottom: 1px solid #f2f2f2;
}

.pIRzhd:first-child {
  padding-top: 0;
}

.pIRzhd:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.B_zHFW {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: 12px;
  line-height: 1.4;
  color: var(--text-neutral-dark);
}

.oPQuOL {
  display: inline-flex;
  align-items: center;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: 12px;
  line-height: 1.4;
  color: var(--status-error);
  white-space: nowrap;
  flex-shrink: 0;
}

.zRLTQH {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: auto;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/NewRechargePage/components/SpreadsheetImportModal/SpreadsheetImportModal.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,8CAA8C;EAC9C,+CAA+C;EAC/C,iBAAiB;AACnB;;AAEA;EACE,2DAA2D;EAC3D,qDAAqD;EACrD,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,eAAe;EACf,cAAc;EACd,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,8BAA8B;EAC9B,mCAAmC;EACnC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,2BAA2B;EAC3B,YAAY;EACZ,8BAA8B;EAC9B,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf;;yBAEuB;AACzB;;AAEA;EACE,2CAA2C;EAC3C,+CAA+C;AACjD;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,+BAA+B;EAC/B,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,2BAA2B;EAC3B,8BAA8B;EAC9B,4CAA4C;EAC5C,uCAAuC;EACvC,oCAAoC;EACpC,uCAAuC;EACvC,eAAe;EACf,cAAc;EACd,+BAA+B;EAC/B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,0CAA0C;EAC1C,+CAA+C;AACjD;;AAEA;;;;EAIE,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,oCAAoC;EACpC,sCAAsC;EACtC,8BAA8B;EAC9B,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,oCAAoC;EACpC,sCAAsC;EACtC,8BAA8B;EAC9B,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,oCAAoC;EACpC,sCAAsC;EACtC,8BAA8B;EAC9B,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kDAAkD;EAClD,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,+CAA+C;EAC/C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,4CAA4C;EAC5C,8CAA8C;EAC9C,sCAAuD;AACzD;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,+BAA+B;EAC/B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,iCAAiC;EACjC,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,QAAQ;EACR,iCAAiC;EACjC,uCAAuC;EACvC,yCAA8D;AAChE;;AAEA;EACE;IACE,QAAQ;EACV;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,8BAA8B;EAC9B,mCAAmC;EACnC,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,8CAA8C;EAC9C,8BAA8B;EAC9B,uCAAuC;EACvC,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,6CAA6C;EAC7C,kBAAkB;EAClB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oCAAoC;EACpC,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB","sourcesContent":[".modal :global(.modal-dialog) {\n  max-width: 560px;\n  margin: 1.75rem auto;\n}\n\n.modal :global(.modal-content) {\n  border-radius: var(--radius-m);\n  border: 1px solid var(--stroke-neutral-subtle);\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);\n  min-height: 448px;\n}\n\n.modalHeader {\n  padding: var(--spacing-3) var(--spacing-3) var(--spacing-2);\n  border-bottom: 1px solid var(--stroke-neutral-subtle);\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: var(--spacing-1);\n}\n\n.modalTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-medium);\n  font-size: 18px;\n  line-height: 1;\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  padding: var(--spacing-0-5);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  max-width: 32px;\n  max-height: 32px;\n}\n\n.modalBody {\n  padding: var(--spacing-3);\n  min-height: 320px;\n  display: flex;\n  flex-direction: column;\n}\n\n.selectionContainer {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  flex: 1 1 auto;\n}\n\n.selectionContainer [data-testid='alert'] {\n  min-width: 0;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.selectionDescription {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-medium);\n  font-size: var(--font-size-md);\n  color: var(--text-neutral-stronger);\n  margin: 0;\n  line-height: 1.4;\n}\n\n.selectionOptions {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2);\n}\n\n.selectionOption {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--spacing-2);\n  padding: var(--spacing-1-5);\n  border: none;\n  border-radius: var(--radius-s);\n  background: var(--surface-neutral-pale);\n  cursor: pointer;\n  text-align: left;\n  transition: background-color 0.2s;\n}\n\n.selectionOption:hover {\n  background-color: var(--surface-primary-subtle);\n}\n\n.selectionOptionSelected {\n  background-color: var(--surface-primary-subtle);\n}\n\n.radioCircle {\n  width: 16px;\n  height: 16px;\n  min-width: 16px;\n  border-radius: var(--radius-pill);\n  border: 1px solid var(--stroke-neutral-dark);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  margin-top: 1px;\n  transition:\n    border-color 0.2s,\n    background-color 0.2s;\n}\n\n.radioCircleSelected {\n  border-color: var(--surface-primary-medium);\n  background-color: var(--surface-primary-medium);\n}\n\n.radioCircleInner {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background-color: var(--surface-neutral-white);\n}\n\n.selectionOptionContent {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1);\n  flex: 1;\n  min-width: 0;\n}\n\n.selectionOptionTitleRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n}\n\n.selectionOptionIcon {\n  color: var(--text-neutral-dark);\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.selectionOptionTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-lg);\n  color: var(--text-neutral-dark);\n  line-height: 1;\n  flex: 1 0 0;\n  min-width: 0;\n}\n\n.selectionOptionDescription {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-sm);\n  color: var(--text-neutral-dark);\n  line-height: 1.6;\n}\n\n.novoBadge {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--spacing-0-5);\n  height: 20px;\n  padding: var(--spacing-0-5);\n  border-radius: var(--radius-s);\n  background-color: var(--success-green-light);\n  border: 1px solid var(--status-success);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: 10px;\n  line-height: 1;\n  color: var(--text-neutral-dark);\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.selectionConfirmButton {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: auto;\n}\n\n.uploadContainer {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2);\n  min-height: 360px;\n}\n\n.uploadContainer [data-testid='fileUploadSpreadsheetImport'] {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.uploadContainer [data-testid='fileUploadSpreadsheetImport'] > label {\n  flex: 1 1 auto;\n  min-height: 280px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.uploadContainer [data-testid='fileUploadSpreadsheetImport-title'] {\n  color: var(--text-neutral-stronger);\n}\n\n.uploadContainer [data-testid='fileUploadSpreadsheetImport-file-error'] {\n  display: none;\n}\n\n.uploadContainer [data-testid='fileUploadSpreadsheetImport'] > label[class*='dragging'] {\n  border-style: dashed;\n  border-color: var(--stroke-primary-bright);\n  background-color: var(--surface-primary-subtle);\n}\n\n.uploadContainer\n  [data-testid='fileUploadSpreadsheetImport']\n  > label[class*='dragging']\n  [data-testid='fileUploadSpreadsheetImport-title'] {\n  color: var(--text-primary-bright);\n}\n\n.uploadContainerError [data-testid='fileUploadSpreadsheetImport-title'] {\n  color: var(--status-error);\n}\n\n.uploadFooter {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.uploadInlineError {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  color: var(--status-error);\n  margin-top: calc(-1 * var(--spacing-1));\n}\n\n.linkButton {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-medium);\n  font-size: var(--font-size-sm);\n  color: var(--text-primary-medium);\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n}\n\n.linkButton:hover {\n  color: var(--text-primary-strong);\n}\n\n.linkButtonMd {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-medium);\n  font-size: var(--font-size-md);\n  color: var(--text-primary-medium);\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n}\n\n.linkButtonMd:hover:not(:disabled) {\n  color: var(--text-primary-strong);\n}\n\n.linkButtonMd:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.backLink {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-medium);\n  font-size: var(--font-size-md);\n  color: var(--text-primary-medium);\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n}\n\n.backLink:hover {\n  color: var(--text-primary-strong);\n}\n\n.instructionsContainer {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2);\n}\n\n.instructionsSteps {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2);\n  max-height: 240px;\n  overflow-y: auto;\n  padding-right: var(--spacing-1);\n  scrollbar-color: var(--icon-neutral-silver, #ccc) transparent;\n  scrollbar-width: thin;\n}\n\n.instructionsSteps::-webkit-scrollbar {\n  width: 4px;\n}\n\n.instructionsSteps::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.instructionsSteps::-webkit-scrollbar-thumb {\n  background-color: var(--icon-neutral-silver, #ccc);\n  border-radius: var(--radius-pill);\n}\n\n.instructionsBody {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  color: var(--text-neutral-stronger);\n  line-height: 1.6;\n  margin: 0;\n}\n\n.instructionsLabel {\n  font-weight: var(--font-weight-medium);\n  color: var(--text-neutral-stronger);\n}\n\n.loadingContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex: 1 1 auto;\n  gap: var(--spacing-3);\n  padding: var(--spacing-3);\n  text-align: center;\n}\n\n.loadingBigIconOrange {\n  width: 72px;\n  height: 72px;\n  border-radius: var(--radius-pill);\n  background-color: var(--surface-primary-subtle);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.loadingSpinner {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  border: 2px solid transparent;\n  border-top-color: var(--text-primary-medium);\n  border-right-color: var(--text-primary-medium);\n  animation: spreadsheet-import-spin 0.9s linear infinite;\n}\n\n@keyframes spreadsheet-import-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.loadingMessage {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-lg);\n  color: var(--text-neutral-dark);\n  line-height: 1.6;\n  margin: 0;\n  max-width: 420px;\n}\n\n.successContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex: 1 1 auto;\n  gap: var(--spacing-3);\n  padding: var(--spacing-3);\n  text-align: center;\n}\n\n.successBigIconGreen {\n  width: 72px;\n  height: 72px;\n  border-radius: var(--radius-pill);\n  background-color: var(--success-green-light);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.successTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-lg);\n  color: var(--text-neutral-dark);\n  line-height: 1.2;\n  margin: 0;\n}\n\n.successDescription {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  color: var(--text-neutral-dark);\n  line-height: 1.6;\n  margin: 0;\n  max-width: 420px;\n}\n\n.successFileName {\n  font-weight: var(--font-weight-semibold);\n}\n\n.successActions {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-2);\n  margin-top: var(--spacing-1);\n}\n\n.uploadProgressContainer {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  flex: 1 1 auto;\n}\n\n.progressCard {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1-5);\n  padding: var(--spacing-1-5);\n  border-radius: var(--radius-s);\n  background: var(--surface-neutral-pale);\n}\n\n.progressContent {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-0-5);\n  flex: 1 1 auto;\n  min-width: 0;\n  justify-content: flex-end;\n}\n\n.progressHeader {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-3);\n  width: 100%;\n}\n\n.progressFileName {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  color: var(--text-neutral-dark);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.progressFileSize {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-sm);\n  color: var(--text-neutral-dark);\n  margin-left: auto;\n  white-space: nowrap;\n}\n\n.progressBarTrack {\n  position: relative;\n  width: 100%;\n  height: 4px;\n  border-radius: var(--radius-pill);\n  background-color: var(--surface-neutral-soft);\n  overflow: hidden;\n}\n\n.progressBarFill {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 0;\n  border-radius: var(--radius-pill);\n  background-color: var(--data-series-02);\n  animation: spreadsheet-import-progress 1s ease-in-out forwards;\n}\n\n@keyframes spreadsheet-import-progress {\n  from {\n    width: 0;\n  }\n  to {\n    width: 100%;\n  }\n}\n\n.progressCancel {\n  background: none;\n  border: none;\n  padding: var(--spacing-0-5);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.uploadProgressActions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: auto;\n}\n\n.fileLoadedContainer {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  flex: 1 1 auto;\n}\n\n.fileLoadedDescription {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-medium);\n  font-size: var(--font-size-md);\n  color: var(--text-neutral-stronger);\n  line-height: 1.4;\n  margin: 0;\n}\n\n.fileCard {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--spacing-2);\n  border: 1px solid var(--stroke-neutral-subtle);\n  border-radius: var(--radius-s);\n  background: var(--surface-neutral-pale);\n  gap: var(--spacing-2);\n}\n\n.fileCardError {\n  border-color: var(--status-error);\n}\n\n.fileCardInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  flex: 1;\n  min-width: 0;\n}\n\n.fileCardNameRow {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-2);\n}\n\n.fileCardName {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  color: var(--text-neutral-dark);\n}\n\n.fileCardSize {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-sm);\n  color: var(--text-neutral-dark);\n  margin-left: auto;\n}\n\n.fileCardDate {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-sm);\n  color: var(--text-neutral-dark);\n  line-height: 1;\n}\n\n.fileCardErrorText {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-sm);\n  color: var(--status-error);\n  line-height: 1.4;\n}\n\n.fileCardRemove {\n  background: none;\n  border: none;\n  padding: var(--spacing-0-5);\n  cursor: pointer;\n  color: var(--text-neutral-medium);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: var(--spacing-2);\n}\n\n.fileCardRemove:hover {\n  color: var(--text-neutral-dark);\n}\n\n.fileLoadedActions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: auto;\n}\n\n.errorContainer {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  flex: 1 1 auto;\n}\n\n.errorActions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: auto;\n}\n\n.validationContainer {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2);\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.validationContainer [data-testid='alert'] {\n  min-width: 0;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.validationFileInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.validationFileName {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  color: var(--text-neutral-dark);\n  line-height: 1.4;\n}\n\n.validationFileDate {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-sm);\n  color: var(--text-neutral-dark);\n  line-height: 1.4;\n}\n\n.validationErrorList {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  max-height: 240px;\n  overflow-y: auto;\n  padding: 16px 12px;\n  background-color: var(--surface-neutral-pale);\n  border-radius: 4px;\n  scrollbar-color: #ccc transparent;\n  scrollbar-width: thin;\n}\n\n.validationErrorList::-webkit-scrollbar {\n  width: 4px;\n}\n\n.validationErrorList::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.validationErrorList::-webkit-scrollbar-thumb {\n  background-color: #ccc;\n  border-radius: var(--radius-pill);\n  min-height: 80px;\n}\n\n.validationErrorRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--spacing-2);\n  padding: 8px 0;\n  border-bottom: 1px solid #f2f2f2;\n}\n\n.validationErrorRow:first-child {\n  padding-top: 0;\n}\n\n.validationErrorRow:last-child {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.validationErrorText {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: 12px;\n  line-height: 1.4;\n  color: var(--text-neutral-dark);\n}\n\n.validationErrorBadge {\n  display: inline-flex;\n  align-items: center;\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: 12px;\n  line-height: 1.4;\n  color: var(--status-error);\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.validationFooter {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `FEBouy`,
	"modalHeader": `gMc1NP`,
	"modalTitle": `ybfEDv`,
	"closeButton": `Tn5pmk`,
	"modalBody": `CDmK63`,
	"selectionContainer": `Kpn5sY`,
	"selectionDescription": `OCLeaJ`,
	"selectionOptions": `gA62t2`,
	"selectionOption": `uG3VoT`,
	"selectionOptionSelected": `Yb72FD`,
	"radioCircle": `WkjZj4`,
	"radioCircleSelected": `eLfKHM`,
	"radioCircleInner": `TsjaG_`,
	"selectionOptionContent": `EFnk7x`,
	"selectionOptionTitleRow": `Xg9wa6`,
	"selectionOptionIcon": `uiKKHo`,
	"selectionOptionTitle": `K1rJu8`,
	"selectionOptionDescription": `zu9eQl`,
	"novoBadge": `fWqgOm`,
	"selectionConfirmButton": `AMUByx`,
	"uploadContainer": `poaLQa`,
	"uploadContainerError": `q3vtLs`,
	"uploadFooter": `yigjFb`,
	"uploadInlineError": `FsJufi`,
	"linkButton": `dGYlIh`,
	"linkButtonMd": `AKNzaN`,
	"backLink": `mDtKSW`,
	"instructionsContainer": `hzWDph`,
	"instructionsSteps": `lxMR3u`,
	"instructionsBody": `_TN0cA`,
	"instructionsLabel": `hM4Gwe`,
	"loadingContainer": `IC72mk`,
	"loadingBigIconOrange": `Wi1JPt`,
	"loadingSpinner": `TzUy5N`,
	"spreadsheet-import-spin": `SwoNGT`,
	"spreadsheetImportSpin": `SwoNGT`,
	"loadingMessage": `MlHfK2`,
	"successContainer": `hD9Bst`,
	"successBigIconGreen": `mPUwYB`,
	"successTitle": `Y75OCw`,
	"successDescription": `A_2_JA`,
	"successFileName": `H4JaAw`,
	"successActions": `ebjh_y`,
	"uploadProgressContainer": `Mhj6Ym`,
	"progressCard": `N7TfNN`,
	"progressContent": `ZwYijr`,
	"progressHeader": `fdDD5X`,
	"progressFileName": `gAiXKV`,
	"progressFileSize": `W9GfC2`,
	"progressBarTrack": `J6OnyZ`,
	"progressBarFill": `jhFw9M`,
	"spreadsheet-import-progress": `G6LHBR`,
	"spreadsheetImportProgress": `G6LHBR`,
	"progressCancel": `Vzd1B6`,
	"uploadProgressActions": `vnEkcb`,
	"fileLoadedContainer": `h5eZ4Y`,
	"fileLoadedDescription": `gt4qZS`,
	"fileCard": `hl1pzK`,
	"fileCardError": `PHw1rr`,
	"fileCardInfo": `D4Y5WU`,
	"fileCardNameRow": `OvqQ4e`,
	"fileCardName": `gFKKQZ`,
	"fileCardSize": `U0xmEY`,
	"fileCardDate": `a3QAHD`,
	"fileCardErrorText": `j_rNGh`,
	"fileCardRemove": `C8Bp2c`,
	"fileLoadedActions": `XWIead`,
	"errorContainer": `MUmRe6`,
	"errorActions": `ifKJc5`,
	"validationContainer": `kxwYku`,
	"validationFileInfo": `_xBWpx`,
	"validationFileName": `Fb49NV`,
	"validationFileDate": `t2BhMO`,
	"validationErrorList": `XBRM1q`,
	"validationErrorRow": `pIRzhd`,
	"validationErrorText": `B_zHFW`,
	"validationErrorBadge": `oPQuOL`,
	"validationFooter": `zRLTQH`
};
module.exports = ___CSS_LOADER_EXPORT___;
